export default "@media screen and (max-height: 700px) {\n    .modal-mini {\n        height: calc(100vh - 150px);\n    }\n    \n}\n";